export const US_STATES_WITH_BOUNDING_BOX = [
  {
    name: "Alabama",
    code: "AL",
    slug: "alabama",
    bbox: [-88.473226, 30.108751, -84.888519, 35.008028],
  },
  {
    name: "Alaska",
    code: "AK",
    slug: "alaska",
    bbox: [-179.9, 51.153306, -129.976002, 71.420291],
  },
  {
    name: "Arizona",
    code: "AZ",
    slug: "arizona",
    bbox: [-111.792612, 32.675272, -111.636942, 32.763052],
  },
  {
    name: "Arkansas",
    code: "AR",
    slug: "arkansas",
    bbox: [-94.617858, 33.004288, -89.640997, 36.499596],
  },
  {
    name: "California",
    code: "CA",
    slug: "california",
    bbox: [-118.096165, 35.057376, -117.914706, 35.228317],
  },
  {
    name: "Colorado",
    code: "CO",
    slug: "colorado",
    bbox: [-109.060187, 36.992497, -102.041791, 41.003422],
  },
  {
    name: "Connecticut",
    code: "CT",
    slug: "connecticut",
    bbox: [-73.727775, 40.94128, -71.787239, 42.050511],
  },
  {
    name: "Delaware",
    code: "DE",
    slug: "delaware",
    bbox: [-75.789021, 38.439699, -74.950092, 39.839517],
  },
  {
    name: "Florida",
    code: "FL",
    slug: "florida",
    bbox: [-87.634787, 24.430341, -79.938023, 31.000966],
  },
  {
    name: "Georgia",
    code: "GA",
    slug: "georgia",
    bbox: [-85.605165, 30.356001, -80.745158, 35.001303],
  },
  {
    name: "Hawaii",
    code: "HI",
    slug: "hawaii",
    bbox: [-178.410818, 18.820221, -154.709598, 28.473416],
  },
  {
    name: "Idaho",
    code: "ID",
    slug: "idaho",
    bbox: [-117.243027, 41.988655, -111.04355, 49.000852],
  },
  {
    name: "Illinois",
    code: "IL",
    slug: "illinois",
    bbox: [-91.513079, 36.970296, -87.079162, 42.570961],
  },
  {
    name: "Indiana",
    code: "IN",
    slug: "indiana",
    bbox: [-88.097892, 37.771764, -84.784533, 42.342346],
  },
  {
    name: "Iowa",
    code: "IA",
    slug: "iowa",
    bbox: [-91.717546, 41.510958, -91.365936, 41.772985],
  },
  {
    name: "Kansas",
    code: "KS",
    slug: "kansas",
    bbox: [-102.051744, 36.993016, -94.588659, 40.003078],
  },
  {
    name: "Kentucky",
    code: "KY",
    slug: "kentucky",
    bbox: [-89.570763, 36.497057, -81.965059, 39.147731],
  },
  {
    name: "Louisiana",
    code: "LA",
    slug: "louisiana",
    bbox: [-94.043354, 28.830565, -88.728414, 33.019615],
  },
  {
    name: "Maine",
    code: "ME",
    slug: "maine",
    bbox: [-71.083931, 42.908759, -66.902733, 47.459843],
  },
  {
    name: "Maryland",
    code: "MD",
    slug: "maryland",
    bbox: [-79.48765, 37.853962, -74.950092, 39.724094],
  },
  {
    name: "Massachusetts",
    code: "MA",
    slug: "massachusetts",
    bbox: [-73.508211, 41.165407, -69.83626, 42.886777],
  },
  {
    name: "Michigan",
    code: "MI",
    slug: "michigan",
    bbox: [-90.412543, 41.696118, -82.145446, 48.305115],
  },
  {
    name: "Minnesota",
    code: "MN",
    slug: "minnesota",
    bbox: [-97.23822, 43.49949, -89.498952, 49.384704],
  },
  {
    name: "Mississippi",
    code: "MS",
    slug: "mississippi",
    bbox: [-91.654908, 30.114528, -88.097888, 34.996098],
  },
  {
    name: "Missouri",
    code: "MO",
    slug: "missouri",
    bbox: [-95.774705, 35.995742, -89.098967, 40.613637],
  },
  {
    name: "Montana",
    code: "MT",
    slug: "montana",
    bbox: [-116.049114, 44.35797, -104.039695, 49.001116],
  },
  {
    name: "Nebraska",
    code: "NE",
    slug: "nebraska",
    bbox: [-96.026064, 40.522925, -95.748572, 40.784109],
  },
  {
    name: "Nevada",
    code: "NV",
    slug: "nevada",
    bbox: [-120.00648, 35.001855, -114.039463, 42.001791],
  },
  {
    name: "New Hampshire",
    code: "NH",
    slug: "new-hampshire",
    bbox: [-72.55694, 42.697042, -70.563681, 45.305493],
  },
  {
    name: "New Jersey",
    code: "NJ",
    slug: "new-jersey",
    bbox: [-75.568122, 38.861551, -73.884719, 41.357606],
  },
  {
    name: "New Mexico",
    code: "NM",
    slug: "new-mexico",
    bbox: [-109.050037, 31.332164, -103.002149, 37.000234],
  },
  {
    name: "New York",
    code: "NY",
    slug: "new-york",
    bbox: [-74.259633, 40.477399, -73.700292, 40.917577],
  },
  {
    name: "North Carolina",
    code: "NC",
    slug: "north-carolina",
    bbox: [-84.321821, 33.765658, -75.375019, 36.588137],
  },
  {
    name: "North Dakota",
    code: "ND",
    slug: "north-dakota",
    bbox: [-104.04892, 45.935171, -96.554438, 49.00057],
  },
  {
    name: "Ohio",
    code: "OH",
    slug: "ohio",
    bbox: [-84.82029, 38.403421, -80.518704, 42.323782],
  },
  {
    name: "Oklahoma",
    code: "OK",
    slug: "oklahoma",
    bbox: [-97.706879, 35.290725, -97.264962, 35.638538],
  },
  {
    name: "Oregon",
    code: "OR",
    slug: "oregon",
    bbox: [-122.666291, 45.241049, -122.381107, 45.409603],
  },
  {
    name: "Pennsylvania",
    code: "PA",
    slug: "pennsylvania",
    bbox: [-80.520233, 39.718695, -74.689754, 42.537705],
  },
  {
    name: "Rhode Island",
    code: "RI",
    slug: "rhode-island",
    bbox: [-71.907099, 41.080796, -71.089578, 42.018799],
  },
  {
    name: "South Carolina",
    code: "SC",
    slug: "south-carolina",
    bbox: [-83.353787, 31.979629, -78.497134, 35.215176],
  },
  {
    name: "South Dakota",
    code: "SD",
    slug: "south-dakota",
    bbox: [-104.057881, 42.480108, -96.43657, 45.945313],
  },
  {
    name: "Tennessee",
    code: "TN",
    slug: "tennessee",
    bbox: [-90.310124, 34.982924, -81.646899, 36.678255],
  },
  {
    name: "Texas",
    code: "TX",
    slug: "texas",
    bbox: [-106.645478, 25.837104, -93.508293, 36.50063],
  },
  {
    name: "Utah",
    code: "UT",
    slug: "utah",
    bbox: [-114.052807, 36.997658, -109.041572, 42.001705],
  },
  {
    name: "Vermont",
    code: "VT",
    slug: "vermont",
    bbox: [-73.437674, 42.726933, -71.465047, 45.035459],
  },
  {
    name: "Virginia",
    code: "VA",
    slug: "virginia",
    bbox: [-83.675395, 36.540855, -75.174174, 39.466012],
  },
  {
    name: "Washington",
    code: "WA",
    slug: "washington",
    bbox: [-124.861672, 45.543637, -116.916072, 49.002595],
  },
  {
    name: "West Virginia",
    code: "WV",
    slug: "west-virginia",
    bbox: [-82.644442, 37.201537, -77.719517, 40.6388],
  },
  {
    name: "Wisconsin",
    code: "WI",
    slug: "wisconsin",
    bbox: [-92.889131, 42.491612, -86.440451, 47.308061],
  },
  {
    name: "Wyoming",
    code: "WY",
    slug: "wyoming",
    bbox: [-111.05456, 40.994808, -104.052245, 45.00582],
  },
];

export const US_STATES = US_STATES_WITH_BOUNDING_BOX.map((state) => ({
  name: state.name,
  code: state.code,
  slug: state.slug,
}));

/** "Texas", "texas", and "TX" all become "TX". Other countries return null. */
export function normalizeUsStateCode(
  state: string | null | undefined,
): string | null {
  const trimmed = state?.trim();
  if (!trimmed) return null;
  const upper = trimmed.toUpperCase();
  const byCode = US_STATES.find((entry) => entry.code === upper);
  if (byCode) return byCode.code;
  const lower = trimmed.toLowerCase();
  const byName = US_STATES.find(
    (entry) => entry.name.toLowerCase() === lower || entry.slug === lower,
  );
  return byName?.code ?? null;
}
